import ar from "./ar";
import en from "./en";

/*
 * our-brands translations live outside the shared dictionary so only this
 * feature's pages download them.
 */
export const ourBrandsTextByLocale = { ar, en };

export function getOurBrandsText(locale) {
  return ourBrandsTextByLocale[locale] ?? ourBrandsTextByLocale.ar;
}
